import classNames from 'classnames'
import { Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'

type LeaveBalanceTemplateProps = {
  className?: string
  leaveType: string
  remaining: number | string
  applied: number | string
  requestedDays: number | string
  requestedRate: number
}

const LeaveBalanceTemplate = (props: LeaveBalanceTemplateProps) => {
  const { className, requestedDays, requestedRate, remaining, leaveType, applied } = props

  if (!applied) return null

  return (
    <div className={classNames('border rounded-lg', className)}>
      <div className="flex flex-col items-center p-4">
        <Typography
          text={i18n.t('label.to_deduct_from_sick_leave', {
            Leavebalancename: `${leaveType}`,
          })}
          variant="body-new/regular"
          textColor="color/fg/lighter"
        />
        <Typography
          text={
            typeof requestedDays === 'string'
              ? requestedDays
              : i18n.t('days_number', { days: requestedDays })
          }
          variant="title-1"
          textColor="color/fg/bold"
        />
      </div>

      <div className="flex items-center border-t border-solid border-0 border-t-color-border-lightest">
        <div className="flex flex-col w-full items-center p-4 border-solid border-0 ltr:border-r ltr:border-r-color-border-lightest ltr:last:border-r-0 rtl:border-l rtl:border-l-color-border-lightest rtl:last:border-l-0">
          <Typography
            text={i18n.t('label.used_payrate', { paymentPercent: `${requestedRate}%` })}
            variant="subtitle-1"
            textColor="color/fg/lighter"
          />
          <Typography
            text={
              typeof requestedDays === 'string'
                ? requestedDays
                : i18n.t('days_number', { days: requestedDays })
            }
            variant="body-new/medium"
            textColor={
              (
                {
                  100: 'color/fg/accent/green/default',
                  0: 'color/fg/accent/red/default',
                } as const
              )[requestedRate] ?? 'color/fg/accent/orange/default'
            }
          />
        </div>
      </div>

      <div className="flex flex-col items-center p-4 border-t border-solid border-0 border-t-color-border-lightest">
        <Typography
          text={i18n.t('label.remaining')}
          variant="body-new/regular"
          textColor="color/fg/lighter"
        />
        <Typography
          text={
            typeof remaining === 'string'
              ? remaining
              : i18n.t('label.count_of_days', { count: remaining })
          }
          variant="title-1"
          textColor="color/fg/bold"
        />
      </div>
    </div>
  )
}

export default LeaveBalanceTemplate
